export default "__VITE_ASSET__CeB_llKm__"